<template>
<div
	ref="modalRef"
	class="modal fade"
	tabindex="-1"
	aria-labelledby="modal-label"
	aria-hidden="true"
	data-bs-keyboard="false"
	:data-bs-backdrop="'static'"
>
	<div class="modal modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-lg-down">
		<div class="modal-content px-5">
			<div class="modal-header px-5">
				<h1 class="modal-title fs-5">Створення нового звіту організації</h1>
			</div>

			<div class="modal-body px-5">
				<Form
					v-if="formValues != null"
					@submit="onSubmit"
					@invalid-submit="console.error"
					:validation-schema="schema"
					:initial-values="formValues"
					v-slot="{ errors, meta: meta, }"
				>
					<div class="row g-2 p-2">
						<div class="form-group col my-2">
							<label>Початок</label>
							<Field
								name="from"
								type="date"
								class="form-control form-control-sm"
								:class="{ 'is-invalid': errors.from }"
							/>
							<div class="invalid-feedback">{{errors.from}}</div>
						</div>

						<div class="form-group col my-2">
							<label>Кінець</label>
							<Field
								name="to"
								type="date"
								class="form-control form-control-sm"
								:class="{ 'is-invalid': errors.to }"
							/>
							<div class="invalid-feedback">{{errors.to}}</div>
						</div>

						<div
							v-show="accountStore.organization.role === 'primary'"
							class="form-group col-12 my-2 mb-0"
						>
							<Field
								name="is_all_organizations"
								type="checkbox"
								id="is-chart"
								class="form-check-input col-auto"
								:class="{ 'is-invalid': errors.is_all_organizations }"
								:value="true"
								:uncheckedValue="false"
							/>
							<label for="is-chart" class="form-check-label mx-2 my-0 col-auto">
								Створити для всіх організацій
							</label>
							<div class="invalid-feedback">{{errors.is_all_organizations}}</div>
						</div>

						<div class="form-group col-12 my-2">
							<label>Примітки</label>
							<Field
								name="comment"
								as="textarea"
								type="text"
								class="form-control form-control-sm h-100 overflow-auto"
								:class="{ 'is-invalid': errors.comment }"
							/>
							<div class="invalid-feedback">{{errors.comment}}</div>
						</div>

						<div class="row justify-content-end my-2 mt-4">
							<span class="form-text fst-italic">
								<p 
									
									class="fs-5"
									:class="{'text-success': executionOk, 'text-danger': !executionOk}"
								>
									{{ executionResultMessage.length > 0 ? executionResultMessage : "&nbsp;" }}
								</p>
							</span>
							<div class="col-auto">
								<button
									type="submit"
									class="btn btn-primary btn-sm"
									:disabled="!meta.valid || blockFormTimeout !== null"
								>
									{{ 'Створити звіт' }}
								</button>
							</div>
						</div>
					</div>
				</Form>
			</div>
		</div>
	</div>
</div>
</template>


<script>
import { Modal } from "bootstrap";
import { useAccontStore } from '@/stores/AccountStore.js'
import {
	rpcTaskSchema,
	useRpcTasks,
} from '@/composables/rpcTasks.js'
// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
import { Form, Field, } from 'vee-validate';
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
import * as Yup from 'yup';


export default {
	waitAfterExecuteSuccessMs: 2100,
	autocleanPromtTimeout: 5000,
	afterSubmitBlockTimeout: 3000,
	wrongInputPromt: 'Не відповідає вимогам',
	requiredPromt: 'Обов\'язкове поле',
	overMinLen: 'Довжина меньше мінімальної',
	overMaxLen: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',

	components: {
		Form,
		Field,
	},

	props: {
	},

	emits: {
		created: null,
		close: null,
	},

	setup() {
		const accountStore = useAccontStore()
		const {
			setFilters,
			createRpc,
			refetch,
		} = useRpcTasks()

		return {
			accountStore,

			setFilters,
			createRpc,
			rpcRefetch: refetch,
		}
	},

	data() {
		const schema = Yup.object().shape({
			from: Yup.date()
				.required()
				.typeError(this.$options.wrongInputPromt)
				.min(new Date(1900, 0, 1)),
			to: Yup.date()
				.required()
				.typeError(this.$options.wrongInputPromt)
				.min(
					Yup.ref('from'),
					"Кінець не може бути раніше початку"
                ),
			is_all_organizations: Yup.boolean()
				.typeError(this.$options.wrongInputPromt)
				.required()
				.default(false),
			comment: Yup.string()
				.typeError(this.$options.wrongInputPromt)
				.transform((value) => (value === '' ? null : value))
				.nullable()
				.min(4, this.$options.overMinLen)
				.max(60, this.$options.overMaxLen)
				.matches(/^[0-9а-яА-Яa-zA-ZґҐєЄіІїЇ "«».,'()№!/\-///—/\n]*$/,
					this.$options.wrongInputPromt),
		})

		return {
			// modal component object
			modal: null,
			//------------------ Form
			schema,
			formValues: null,
			organizations: [],
			//------------------
			//  
			executionResultMessage: '',
			executionOk: null,
			cleanTimeout: null,

			// For blocking form after submit.
			blockFormTimeout: null,
		}
	},

	async created() {
		this.formValues = {
			from: this.monthFirstDayDate,
			to: this.monthLastDayDate,
			is_all_organizations: false,
		}
	},

	async mounted() {
		// Get modal object
		this.modal = new Modal(this.$refs.modalRef)

		// This event is fired when the modal is shown, its backdrop is static
		// and a click outside of the modal is performed. The event is also
		// fired when the escape key is pressed and the keyboard option is set to false.
		this.$refs.modalRef.addEventListener('hidePrevented.bs.modal', this.close)

		// Show modal popup
		this.modal.show()
	},

	methods: {
		onCancel() { this.close(); },

		// Return formated date YYYY-MM-DD
		formatDate(date) {
			return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
		},

		async checkActiveTask() {
			this.setFilters({
				isComplete: false,
			})

			const result = await this.rpcRefetch()
			if (result.error) {
				return null
			}

			return result.data ?? []
		},

		async onSubmit(values) {
			// display form values on success
			//console.log("Form: ", values);

			this.executionResultMessage = ''
			this.autoBlockForm()

			// Check station for active RPCs
			const taskInQueue = await this.checkActiveTask()
			
			if (taskInQueue === null) {
				this.printErr("Сталась помилка. Сервер відхилив запит.")
				return
			} else if (taskInQueue.length > 0) {
				this.printErr("Обробляється інший запит. Будь ласка дочекайтесь його виконання.")
				return
			}
			//console.log("Task in queue =", taskInQueue)

			values[rpcTaskSchema.context.from.key] = new Date(values[rpcTaskSchema.context.from.key])
			values[rpcTaskSchema.context.to.key] = new Date(values[rpcTaskSchema.context.to.key])
			values.writer = {
				"name": this.accountStore.userName,
				"id": this.accountStore.userId,
				"organization": {
					"name": this.accountStore.organization["title"],
					"id": this.accountStore.organization["_id"],
				},
			}

			const result = await this.createRpc(
				this.accountStore.userId,
				rpcTaskSchema.job.allowed.buildOrganizationReport.key,
				null,
				this.accountStore.organization["_id"],
				values
			)

			if (result) {
				this.printHint("Запит надіслано. Спостерігайте за його станом.")
				this.$emit('created')

				setTimeout(
					() => {
						this.close()
					},
					this.$options.waitAfterExecuteSuccessMs
				);
			} else {
				this.printErr("Сталась помилка. Сервер відхилив запит.")
			}
		},

		// Close popup
		close() {
			this.modal.hide()
			this.$emit("close");
		},

		printHint(msg) {
			this.executionResultMessage = msg
			this.executionOk = true
			this.autoCleanPromt()
		},

		printErr(msg) {
			this.executionResultMessage = msg
			this.executionOk = false
			this.autoCleanPromt()
		},

		autoCleanPromt() {
			if (this.cleanTimeout !== null) {
				clearTimeout(this.cleanTimeout)
				this.cleanTimeout = null
			}

			this.cleanTimeout = setTimeout(
				() => {
					this.executionResultMessage = ""
					this.executionOk = null
				},
				this.$options.autocleanPromtTimeout
			);
		},

		autoBlockForm() {
			if (this.blockFormTimeout !== null) {
				clearTimeout(this.blockFormTimeout)
				this.blockFormTimeout = null
			}

			this.blockFormTimeout = setTimeout(
				() => {
					clearTimeout(this.blockFormTimeout)
					this.blockFormTimeout = null
				},
				this.$options.afterSubmitBlockTimeout
			);
		},
	},

	computed: {
		monthFirstDayDate () {
			const date = new Date();
			const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
			return this.formatDate(firstDay)
		},

		monthLastDayDate () {
			const date = new Date();
			const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
			return this.formatDate(lastDay)
		},
	},

	beforeUnmount() {
		// Remove event listener which created in mounted()
		this.$refs.modalRef.removeEventListener('hidePrevented.bs.modal', this.close)
	},
};
</script>


<style scoped>
</style>
	